"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
const core_2 = require("@ngx-translate/core");
const plugin_manager_service_1 = require("../../../service/plugin-manager.service");
const FourDInjector_1 = require("../../FourDInjector");
class PluginUiComponent {
    constructor(pluginManager) {
        this.pluginManager = pluginManager;
        this.plugin = null;
        this.item = null;
        this.context = null;
        this.reference = null;
        this.groups = {};
        this.groupCounter = 1;
        this.currentGroup = null;
        this.translate = null;
        this.lastMouseEvent = null;
        this.currentTab = 'main';
        // Preserve original property order
        this.originalOrder = (a, b) => {
            return 0;
        };
        // Order by ascending property value
        this.valueAscOrder = (a, b) => {
            return a.value.localeCompare(b.value);
        };
        // Order by descending property key
        this.keyDescOrder = (a, b) => {
            return a.key > b.key ? -1 : (b.key > a.key ? 1 : 0);
        };
        this.translate = FourDInjector_1.FourDInjector.injector.get(core_2.TranslateService);
    }
    ngOnChanges() { }
    ngOnInit() {
        // console.log('UI-comp', this.plugin, this.item, this.context );
        // console.log('UI-comp controls', this.plugin.controls );
    }
    ngOnDestroy() {
        this.reference = null;
        this.plugin = null;
        this.context = null;
        this.item = null;
    }
    mouseclicks(event = null) {
        this.lastMouseEvent = event;
        // console.log('clickety',event);
    }
    deletePlugin() {
        if (!this.context) {
            return;
        }
        let pluginId = this.plugin.id;
        let item = this.plugin.item;
        if (this.plugin.controller) {
            // console.log('delete ctrl',this.plugin.controller);
            this.plugin.controller.delete(pluginId, item);
        }
        else if (this.context && this.context.deletePlugin) {
            // console.log('delete context',this.context);
            this.context.deletePlugin(pluginId, item);
        }
        if (this.plugin) {
            this.plugin = null;
        }
    }
    checkGroups(ctrl) {
        let key = ctrl.key;
        let ctrls = ctrl.value;
        let group = ctrls['group'] ? ctrls.group : null;
        if (group) {
            if (!this.groups[group]) {
                this.groups[group] = { idx: this.groupCounter++, first: key, last: null, show: false };
            }
            this.currentGroup = group;
            return true;
        }
        return false;
    }
    getGroupIndex(ctrl) {
        let ctrls = ctrl.value;
        let group = ctrls['group'] ? ctrls.group : null;
        if (this.groups[group]) {
            return this.groups[group].idx;
        }
        return null;
    }
    isFirstInGroup(ctrl) {
        let key = ctrl.key;
        let ctrls = ctrl.value;
        let group = ctrls['group'] ? ctrls.group : null;
        if (this.groups[group] && this.groups[group].first == key) {
            return true;
        }
        return false;
    }
    isFirstNongroup(ctrl) {
        let ctrls = ctrl.value;
        let group = ctrls['group'] ? ctrls.group : null;
        if (!group && this.currentGroup) {
            this.currentGroup = null;
            return true;
        }
        return false;
    }
    getReference(refId) {
        if (this.plugin && refId && this.plugin.controls && this.plugin.controls[refId]) {
            this.reference = this.plugin.controls[refId];
            return true;
        }
        return false;
    }
}
exports.PluginUiComponent = PluginUiComponent;
